import * as _ from 'lodash';
import type { FunctionComponent, ReactNode } from 'react';

import { formatCount, prettyNumber } from '../../../../../../shared/utils/numbers';
import Badge from '../../../../generic/Badge/Badge';
import Icon from '../../../../generic/Icon/Icon';
import type { IconClassName } from '../../../../generic/Icon/icons';

import styles from './InfoCard.module.less';

type Props = {
  title: string;
  icon: IconClassName;
  count?: number;
  children: ReactNode;
};

/**
 * Shared chrome for the project summary info cards. Renders a card panel
 * with a header (icon + title + optional count badge) and an arbitrary body.
 */
export const InfoCard: FunctionComponent<Props> = ({
  title,
  icon,
  count,
  children,
}) => (
  <div className={styles.card}>
    <div className={styles.header}>
      <span className={styles.icon}>
        <Icon icon={icon} />
      </span>
      <span className={styles.title}>{title}</span>
      {_.isNumber(count) && (
        <div className={styles.count}>
          <Badge color="light-gray" shape="circle" size="micro" title={prettyNumber(count)}>
            {formatCount(count)}
          </Badge>
        </div>
      )}
    </div>
    <div className={styles.body}>{children}</div>
  </div>
);
